module.exports = __webpack_public_path__ + "img/icon_collect.f3d2d3a2.svg";